import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseElement } from '../base/base-element.js';

/**
 * Full-screen overlay that displays count-in numbers ("1", "2", "3", "Go!")
 * over the alphaTab container before playback starts.
 */
@customElement('count-in-overlay')
export class CountInOverlay extends BaseElement {
    static styles = [
        BaseElement.styles,
        css`
            :host {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                align-items: center;
                justify-content: center;
                background: rgba(15, 23, 42, 0.75);
                z-index: 15;
                pointer-events: none;
            }

            :host([active]) {
                display: flex;
            }

            .count-in-text {
                font-size: 6rem;
                font-weight: 700;
                color: #fff;
                text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
                animation: count-in-pop 0.35s ease-out both;
            }

            @keyframes count-in-pop {
                0% {
                    transform: scale(0.4);
                    opacity: 0;
                }
                60% {
                    transform: scale(1.15);
                    opacity: 1;
                }
                100% {
                    transform: scale(1);
                    opacity: 1;
                }
            }
        `,
    ];

    @property({ type: Boolean, reflect: true })
    active = false;

    @property()
    text = '';

    updated(changedProperties: Map<string, unknown>): void {
        // Retrigger pop animation when text changes
        if (changedProperties.has('text') && this.text) {
            const el = this.shadowRoot?.querySelector('.count-in-text') as HTMLElement | null;
            if (el) {
                el.style.animation = 'none';
                void el.offsetHeight; // force reflow
                el.style.animation = '';
            }
        }
    }

    render() {
        return html`<span class="count-in-text">${this.text}</span>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'count-in-overlay': CountInOverlay;
    }
}
